import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SubPageStatusIcon = ({ icon, tooltip, iconColor }) => {
  return (
    <div className="m-2 position-absolute top-0 start-0">
      <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
        <FontAwesomeIcon icon={icon} className={iconColor} />
      </OverlayTrigger>
    </div>
  );
};
export default SubPageStatusIcon;
